<template>
  <ClientOnly>
    <div class="home_container" :class="appConfig.getTemplateClass">
      <!-- 当前主题：{{theme}} -->
      <!-- <button @click="store.toggleTheme">切换主题</button> -->
      <div class="wrap" v-if="!isNanTong">
        <div class="w-100% m-auto">
          <van-image v-if="theme === 'light'" width="80vw" class="w-100%"
            :src="getProjectImageUrl('errImg', 'error.png')" />
          <van-image v-else width="80vw" class="w-100%" :src="getProjectImageUrl('errImg', 'error_drak.png')" />
        </div>
        <div style="color: #a2a9b9" class="mt-4 text-center">页面丢失，请稍后尝试</div>
        <div style="color: #5ea8ff; text-decoration: underline" class="text-center mt-10" @click="reloadEvent">
          点击刷新
        </div>
      </div>
      <div class="wrap -mt-[200px]" v-if="isNanTong">
        <div class="w-100% m-auto">
          <van-image width="50vw" class="w-100%" src="/images/light/404.png" />
        </div>
        <div style="color: #363636" class="mt-[0px] text-[12px] font-normal text-center">抱歉，页面丢失啦~</div>
        <div class="text-center mt-10 refresh" @click="reloadEvent">
          <span>立刻刷新</span>
        </div>
      </div>
      <div v-if="!isNanTong" style="font-size: 14px; color: #a2a9b9">已切换到wifi环境</div>
    </div>
  </ClientOnly>
</template>
<script lang="ts" setup>
import { getProjectImageUrl } from '~/composables/useUtil';
const store = useGlobalStore()
const { theme, isNanTong, appConfig } = storeToRefs(store)

const reloadEvent = () => {
  window.location.href = window.location.origin
}
</script>
<style lang="scss" scoped>
.home_container {
  height: 100vh;
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .wrap {
    font-size: 14px;
    // max-height: 00px;
  }
}

.nantong {
  background: linear-gradient(170deg, #FFF 6.3%, #D4D4E8 97.94%);
}

.refresh {
  display: flex;
  width: 120px;
  height: 40px;
  padding: 6px 29px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #000;
  margin-left: 50%;
  transform: translateX(-50%);
}
</style>
